import { PRODUCT_MARK_BLUE } from "@/lib/product";

// The bare X glyph from the DenteX artwork — the monogram for tight chrome
// (collapsed sidebar rail). The viewBox is the glyph's own bounds inside the
// 512 icon grid, so it scales edge-to-edge.
//
// Flat PRODUCT_MARK_BLUE, not a gradient: this used to be filled #273d90 →
// #2061ab, an indigo that visibly disagreed with the dentex-wordmark.png shown
// one state over in the expanded rail (#0E608F–#1571A0) and with app/icon.svg
// (#1571A0). Collapsing the sidebar changed the brand's colour. The dark lift
// is the same filter the wordmark raster gets, so both derive one way from one
// source.
export function ProductGlyph({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="85 130 415 250"
      className={`dark:brightness-[1.45] dark:saturate-[1.15] ${className ?? ""}`}
      role="img"
      aria-label="DenteX"
    >
      <g transform="translate(-926.720,136.710) scale(2.98674)">
        <path
          d="M385.23,59.29l-20.09,20.59h-25.93l33.73-34.45,12.3,13.85ZM340.42,0h40.55l71.59,79.88h-40.55L340.42,0ZM405.93,18.6L423.95,0h25.94l-31.54,32.33-12.42-13.73Z"
          fill={PRODUCT_MARK_BLUE}
        />
      </g>
    </svg>
  );
}

// The DenteX product mark — the same artwork as app/icon.svg (favicon / PWA
// icons), inlined as a component so chrome surfaces (login hero, sidebar
// footers) can render it at any size without an extra asset fetch.
export function ProductLogo({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      className={className}
      role="img"
      aria-label="DenteX"
    >
      <defs>
        <linearGradient
          id="dentexLogoBg"
          x1="0"
          y1="0"
          x2="512"
          y2="512"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#273d90" />
          <stop offset="1" stopColor="#2061ab" />
        </linearGradient>
      </defs>
      <rect width="512" height="512" rx="112.64" ry="112.64" fill="url(#dentexLogoBg)" />
      <g transform="translate(-926.720,136.710) scale(2.98674)">
        <path
          d="M385.23,59.29l-20.09,20.59h-25.93l33.73-34.45,12.3,13.85ZM340.42,0h40.55l71.59,79.88h-40.55L340.42,0ZM405.93,18.6L423.95,0h25.94l-31.54,32.33-12.42-13.73Z"
          fill="#ffffff"
        />
      </g>
    </svg>
  );
}
